import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Button, Input, InputNumber } from "antd";
import { API_URLS } from "../../../api/apiUrls";
import { putApi } from "../../../api/api_instance";
// import { toast } from "react-hot-toast";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const EditProjectTypeDialog = ({ onOpen, onClose, projectData, onUpdate }) => {
  const [project_type, setprojectType] = useState("");
  const [description, setDescription] = useState("");
  const [service_cost, setServiceCost] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);

  const [errorMessage, setErrorMessage] = useState({
    project_type: "",
    description: "",
    service_cost: "",
  });

  useEffect(() => {
    if (projectData) {
      setprojectType(projectData.project_type || "");
      setDescription(projectData.description || "");
      setServiceCost(projectData.service_cost ? projectData.service_cost : null);
    }
  }, [projectData]);
  const handleSave = async () => {
    let isValid = true;
    const errors = { project_type: "", description: "", service_cost: "" };

    if (!project_type) {
      errors.project_type = "Project Type is required";
      isValid = false;
    }
    if (!description) {
      errors.description = "description is required";
      isValid = false;
    }
    if (service_cost === undefined || service_cost === null || service_cost < 0) {
      errors.service_cost = "Valid service cost is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);

    try {
      const response = await putApi({
        apiUrl: API_URLS.EDIT_PROJECT_TYPE(projectData._id),
        data: { project_type, description, service_cost },
      });

      if (response.success) {
        // toast.success("Project Type updated successfully!");
        onUpdate();
        setShowAcceptDialog(true);
      } else {
        console.error(response.message || "Update failed.");
      }
    } catch (error) {
      console.error(error.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">
            Edit Project Type
          </h3>
        </div>
        <div className="rounded-xl border mt-8 px-12 pt-3">
       
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <label htmlFor="project_type" className="text-sm font-medium text-gray-700 text-left">Project Type</label>
              <Input
                id="project_type"
                value={project_type}
                onChange={(e) => setprojectType(e.target.value)}
                placeholder="Project Type"
                className="h-14 rounded-lg"
              />
              {errorMessage.project_type && (
                <div className="text-red-500 text-sm text-left">
                  {errorMessage.project_type}
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="description" className="text-sm font-medium text-gray-700 text-left">Description</label>
              <Input
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Description"
                className="h-14 rounded-lg"
              />
              {errorMessage.description && (
                <div className="text-red-500 text-sm text-left">
                  {errorMessage.description}
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="service_cost" className="text-sm font-medium text-gray-700 text-left">Service Cost (₹)</label>
              <InputNumber
                id="service_cost"
                value={service_cost}
                onChange={(value) => setServiceCost(value)}
                placeholder="Service Cost"
                className="w-full h-14 rounded-lg flex items-center"
                
              />
              {errorMessage.service_cost && (
                <div className="text-red-500 text-sm text-left">
                  {errorMessage.service_cost}
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={onClose}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DailogBox>

      {showAcceptDialog && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="success"
            title="Project Type Updated"
            message="Project Type have been successfully updated."
            autoClose={true}
            autoCloseMs={3000}
            onClose={() => {
              setShowAcceptDialog(false);
              onClose();
            }}
          />
        </div>
      )}
    </>
  );
};

export default EditProjectTypeDialog;
